// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__UWQPD","text":"SelectPayment_text__2XPBT","title":"SelectPayment_title__1gAAd","btn":"SelectPayment_btn__ceLpI"};